import { ChangeDetectorRef, Component, HostListener, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { environment } from '../../environments/environment';
import { Clientes } from '../cliente';
import { ClienteService } from '../cliente.service';
import { CuentasxcobrarService } from '../cuentasxcobrar.service';
import { CxC } from '../cxc';
import { cxcRetencion } from '../cxcRetencion';

@Component({
  selector: 'app-cuentasxcobrar',
  templateUrl: './cuentasxcobrar.component.html',
  styleUrls: ['./cuentasxcobrar.component.scss']
})
export class CuentasxcobrarComponent implements OnInit {
  listaCXC: CxC[] = [];
  cxcActuliza: CxC;
  listaCXCActulizar: CxC[] = [];
  listCliene: Clientes[];
  entidadCxC: CxC = new CxC();
  entidadCxRetencion: cxcRetencion = new cxcRetencion();

  idCliente: string;
  cliente: Clientes = new Clientes();
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  @ViewChild('modalRetencion') public mdbModalRetencion: ModalDirective;

  data: CxC[] = [];
  previous: any = [];
  isLoadingResults = true;

  constructor(private apiClien: ClienteService, private ruter: Router, private alertService: AlertService, private api: CuentasxcobrarService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }
  ngDoCheck() {


  }




  buscarCedula() {

    console.log(this.idCliente);
    this.apiClien
      .getCliente(
        this.idCliente)
      .subscribe(
        (data: Clientes[]) => {
          data.forEach((item) => {
            this.cliente = item;

          });
        },
        (err) => {
          this.alertService.danger("Problemas con la conexión");
        }
      );
  }


  listarProveedor() {
    this.apiClien
      .getClientes(
        localStorage.getItem("id")
      )
      .subscribe(
        (data: Clientes[]) => {
          this.listCliene = data;
          console.log(this.listCliene);
        });
  }

  agregarModal() {
    this.entidadCxC = new CxC();
    this.mdbModal.show();
  }

  agregarRetencion(cxc) {
    this.entidadCxRetencion = new cxcRetencion();
    this.mdbModalRetencion.show();
  }

  actualizar() {
    this.entidadCxC.idCliente = this.cliente.codcliente;
    this.entidadCxC.nombres = this.cliente.nombrerazonsocial;
    this.entidadCxC.identificacion = this.cliente.numeroidentificacion;
    this.entidadCxC.id = 0;
    this.entidadCxC.saldo = this.entidadCxC.valor
    this.entidadCxC.idEmisor = this.cliente.idEmisor;
    this.entidadCxC.enviado='S'
    this.listaCXCActulizar[0] = this.entidadCxC;
    this.api.setActulizar(this.listaCXCActulizar).subscribe(

      data => {
        this.mdbModal.hide();
        this.alertService.info("Se Guardo con exito...")
        this.listarCXC();
      },

      error => {

        this.alertService.danger(error)

      });

  }

  agregar(entidad: CxC) {
    this.ruter.navigate(['abonos', { id: entidad.id }]);
  }


  eliminar(entidad: CxC) {
    if (confirm("Está seguro de anular la Cuenta por Cobrar")) {
      if (entidad.factura == '0') {
        this.api.eliminar(entidad.id).subscribe(

          data => {
            this.alertService.success("Se elimino con exito..");
            this.listarCXC();

          },

          error => {

            this.alertService.danger(error)

          }

        );

      } else {
        this.alertService.warning('No se puede eliminar la Cuenta por Cobrar, anule la Venta...');
      }
    }
  }

  onChangeCompra(newValue) {
    this.entidadCxC.tipoDoc=newValue.target.value;
  }

  print(idFac){
    let url=environment.apiReportes+"factura.rptdesign&__format=pdf&id="+idFac;
    const WindowPrt =   window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
   

  }
  listarCXC() {

    this.api.getCuentasxCobrar(localStorage.getItem('id'))
      .subscribe((
        data: CxC[]) => {
        this.listaCXC = data;
        this.listaCXC.forEach(element => {
          if (element.tipoDoc === 'F') {
            element.tipoDoc = 'FACTURA';
          }
          if (element.tipoDoc === 'R') {
            element.tipoDoc = 'RECIBO';

          }
          if (this.variableNula(element.numeroDocumento)==true) {
            element.numeroDocumento = this.PadLeft(element.numeroDocumento, 9);
          }
        });
        console.log(this.listaCXC);
        this.mdbTable.setDataSource(this.listaCXC);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      }
        , err => {
          console.log(err);
          this.isLoadingResults = false;
        });
  }

  onChange1(ev) {
    this.idCliente = ev;
    this.buscarCedula();

  }


  variableNula(valor) {

    if (valor == null || valor == undefined || valor == "null" || 
    valor == "undefined") { 
      return false } else { 
        return true }

  }

  PadLeft(value, length) {
    return (value.toString().length < length) ? this.PadLeft("0" + value, length) :
      value;
  }

  ngOnInit() {
    this.listarCXC();
    this.listarProveedor();


  }


  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {

    this.cdRef.detectChanges();
  }

  changeValue() {


  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.listaCXC = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.listaCXC = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

}
